import { combineReducers } from "@reduxjs/toolkit";
import planInfoSummary from "./plan-info-summary";

const planInfoSummaryReducer = combineReducers({
  planInfoSummary,
});

export default planInfoSummaryReducer;
